import { isDebugMode } from './isDebugMode';
export const logEvent = (event, message) => {
  const GA_LOG_PREFIX = 'GoogleTagManager | ';
  if (isDebugMode()) {
    console.log(GA_LOG_PREFIX + (message ?? 'Event') + ': ' + JSON.stringify(event, null, '  '));
  }
  return event;
};